import AppLayout from '@/layouts/AppLayout.vue';

import AdminListView from '@/views/users/admin/AdminListView.vue';
import DamListView from '@/views/users/dam/DamListView.vue';
import UserListView from '@/views/users/b2c/UserListView.vue';
import DetailUserView from '@/views/users/b2c/DetailUserView.vue';
import UserProfileView from "@/views/UserProfileView.vue";

import UserService from '@/services/user/userService.ts';
import LcbftService from '@/services/lcbft/lcbftService.ts';
import ClientDeclarationService from '@/services/user/clientDeclarationService.ts';
import InvestorFormService from '@/services/user/investorFormService.ts';
import KycDocumentService from '@/services/user/kycDocumentService.ts';

import type { RouteLocationNormalized } from 'vue-router';

export default [
  {
    path: '/administrators',
    name: 'administrators',
    component: AdminListView,
    meta: {
      parent: 'usersManagement',
      related: 'administrators',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['GET_USER_ADMIN']
    }
  },
  {
    path: '/dams',
    name: 'dams',
    component: DamListView,
    meta: {
      parent: 'usersManagement',
      related: 'dams',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['GET_USER_DAM', 'GET_USER']
    }
  },
  {
    path: '/users',
    name: 'users',
    component: UserListView,
    meta: {
      parent: 'usersManagement',
      related: 'users',
      layout: AppLayout,
      requiresAuth: true,
      inNav: true,
      permissions: ['GET_USER']
    }
  },
  {
    path: '/users/:id/detail',
    name: 'detailUser',
    component: DetailUserView,
    meta: {
      parent: 'usersManagement',
      related: 'users',
      layout: AppLayout,
      requiresAuth: true,
      inNav: false,
      permissions: ['GET_KYC']
    },
    async beforeEnter(to: RouteLocationNormalized) {
      const userId = Number(to.params.id)

      try {
        to.meta.user = await UserService.getB2CUser(userId)
      } catch (_) {
        return { path: '/users' }
      }

      // Best-effort enrichment blocks: each of these already resolves to null/[] on its own
      // (including on a 404 "not filled in yet"), so a missing questionnaire/classification/
      // documents never blocks the rest of the page from loading.
      const [lcbft, clientDeclaration, investorForm, kycDocuments] = await Promise.allSettled([
        LcbftService.getClassification(userId),
        ClientDeclarationService.getClientDeclaration(userId),
        InvestorFormService.getInvestorForm(userId),
        KycDocumentService.getKycDocuments(userId)
      ])

      to.meta.lcbft = lcbft.status === 'fulfilled' ? lcbft.value : null
      to.meta.clientDeclaration = clientDeclaration.status === 'fulfilled' ? clientDeclaration.value : null
      to.meta.investorForm = investorForm.status === 'fulfilled' ? investorForm.value : null
      to.meta.kycDocuments = kycDocuments.status === 'fulfilled' ? kycDocuments.value : []
    }
  },
  {
    path: '/user/profile',
    component: UserProfileView,
    meta: {
      layout: AppLayout,
      inNav: false,
      requiresAuth: true
    }
  }
];
